import { render, staticRenderFns } from "./BranchName.vue?vue&type=template&id=00b26a10"
import script from "./BranchName.vue?vue&type=script&lang=js"
export * from "./BranchName.vue?vue&type=script&lang=js"
import style0 from "./BranchName.vue?vue&type=style&index=0&id=00b26a10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports